import { createApp } from "vue";
import { ModalHelper } from "../B2bTools";
import Store from "../Store";
import hash from "../hash";
import { may, toPrix } from "./composant/b2bLangue";

import { Splide } from "@splidejs/splide";
import { Video } from "@splidejs/splide-extension-video";

import Drift from "drift-zoom";

const imagPardefaut = "0000000/0000000_0000_1_L.png";

import html from "./productSaisie.html";
import htmlZoom from "./productSaisieZoom.html";

/*
    Qt initil :     Qt importée
    Qt commandé :   Qt validée et exporté dans M3
    Qt reserv :     Qt saisie dans les lignes panier

    Stockreel :     Qt initial - Qt commandée
    stockdispo :    Qt initial - Qt commandée - Qt stockreserve

    Si il y a une Qt ligne brouillon :
      si Stockreel>0  => stockdispo + qt brouillon

    st[0].stockdispo + qt = 
    product.ct[key] ? product.ct[key].qt
    st[0].stockdispo + qt = 
*/

function buildUvcSaisies(product, cou1, stocks, codestock) {
  const uvcSaisies = [];
  // spécial LBT 
  let cou = product.cou[0].k;
  let productstocks = []; 

  if(product.stock && product.stock.rows && product.stock.rows) productstocks = product.stock.rows;
  if(productstocks.filter(s => s.codestock == codestock).length > 0) productstocks = productstocks.filter(s => s.codestock == codestock)


  // console.log(`🏗️ codestock`,codestock)
  // console.log(`🏗️ productstocks`,productstocks)

  product.tai.forEach(tail => {
    const k = tail.k + "_" +cou ;
    let uvc = product.uvc[cou + "_" +tail.k];
    let saisie = product.ct[cou + "_" +tail.k];
    uvc.qt = (saisie && saisie.qt) ? saisie.qt : 0;

    // console.log(`🏗️   k ${k}`, product.ct[cou + "_" +tail.k])
    if (codestock && productstocks.length > 0) {
      // console.log(`🏗️   k ${k}`, product.ct[cou + "_" +tail.k])
      let stocksbycode = productstocks[0].stock.filter(s => s.codestock == codestock);
      //
      //console.log(stocksbycode)
      uvc.ostock = {};
      uvc.ostock.stockdispo = 0;
      uvc.ostock.stockreel  = 0;
      uvc.ostock.sasissable = 0;
      uvc.ostock.stockdispo = 0;
      //
      if (stocksbycode.length > 0) {
        //
        let a = stocksbycode.find(s => s.ean == uvc.ean);
        if (!a) a = {}
        //
        uvc.ostock = {};
        uvc.ostock.stockreel = a.stockreel || 0;
        uvc.ostock.stockdispo = a.stockdispo || 0;
        uvc.ostock.sasissable = uvc.ostock.stockdispo + uvc.qt;
        console.log(uvc.qt)
      }
    }

    uvcSaisies.push(uvc)
  })
  return uvcSaisies;
}




const js = {
  topbar: true,
  url: function (echangeur) {


    const orderManagerData = Store.get("getData")();
    // console.log(`🛒 url orderManagerData`,orderManagerData.currentOrder);
    // const orderManagerData = orderManagerDatas();
    const univers = Store.get('getURUL')();

    const p = { reference: echangeur.hash.reference };
    let onstock = false;

    if (orderManagerData.currentOrder && orderManagerData.currentOrder._id) {
      p._id = orderManagerData.currentOrder._id;
      onstock = (orderManagerData.currentOrder.onstock);
    } else {
      p.linelist = echangeur.hash.linelist;
    }

    p.env = univers;

    echangeur.addAction("b2b.saisie.get", p, "", "product");

    // echangeur.addAction('b2b.stock.get', { ref: echangeur.hash.reference, tocK: echangeur.hash.tocK }, '', 'stock');
  },
  onLoad: function (echangeur) {

    //console.log('echangeur', echangeur.product);

    let THIS = this;

    const env = Store.get("getURUL")();
    const orderManagerData = Store.get("getData")();

    // console.log(`🛒 onLoad orderManagerData`,orderManagerData.currentOrder);



    const CTX = Store.get("CTX");
    const mayCreateOrder = CTX.session.droits.CREORD;

    const app = createApp({
      data: function () {
        const product = echangeur.product;
        const reference = product.reference;
        //const cou = product.cou[0]; // 1ere couleur pour test
        //
        const lcodestock = (product.toc.onstock && product.stock) ? product.stock.lcodestock : [];
        const codestock = (orderManagerData?.currentOrder?.codestock) ? orderManagerData?.currentOrder?.codestock : null;
        const stocks    = (product.stock && product.stock.rows) ? product.stock.rows : [];
        //
 
        // const uvcSaisies = buildUvcSaisies(product, cou, stock);
        //
        const uvcSaisies = buildUvcSaisies(product, null, null, codestock);
        //console.log('uvcSaisies', uvcSaisies);
        const media = [];

        if (product.imgs.length) {
          for (let item of product.imgs) media.push({ type: "image", src: `download/product/${item.replace("*", "L")}`, });
        } else {
          media.push({ type: "noimage", src: `download/product/${imagPardefaut}`, });
        }

        if (product.videos.length) {
          for (let item of product.videos) {
            media.push({ type: "video", src: `download/product/${item.split("_")[0]}/${item}`, });
          }
        }
        // console.log('currentOrder',orderManagerData.currentOrder);
        return {

          onstock: (product.toc && product.toc.onstock), // affichage en stock ou non
          stocks: stocks,        // tableau des stocks
          lcodestock: lcodestock,    // liste des code stock 
          codestock: codestock,     // code stock utilisée pour la saisie

          currentStartImage: 0,

          images: (product.imgs.length ? product.imgs : [imagPardefaut]).map((u) => "download/product/" + u.replace("*", "L")),
          //videos: ((product.videos.length) ? product.videos : []).map(u => "download/product/" + u.split("_")[0] + '/' + product.videos),

          media,
          activeMedia: 0,
          currentOrder: orderManagerData.currentOrder, //  ? orderManagerData.currentOrder : null,
          product: {
            _id: reference._id,
            product: product,
            reference: reference,
            couV: product.couV,
            v: product.v,
            macrofamily: product.macrofamily,
            family: product.family,
            collectiontype: product.collectiontype,
            collectiongroup: product.collectiongroup,
            haut: product.haut,
            prixGlobal: 0,
            //
            line: product.line,
            prixRetail: product.prixRetail,
            prixWholesale: product.prixWholesale,
            deliverytheme: product.deliverytheme,
            communication: product.communication, 
            flags: product.flags,
            verifie: product.verifie,
            savethe: product.savethe,
            savethefrom: product.savethefrom,
          },
          isTailleunique: product.tai.length === 1, // ne fait pas apparaitre global quantity
          saisie: {
            uvc: uvcSaisies,
            isGlobal: product.isGlobal,
            qtGlobal: product.glob.qt, //glob
          },
          tdcustom: "min-width: 45px !important; max-width: 45px !important;",

          thumbnails: echangeur.product.imgs.map((u) => `download/product/${reference}/${u}`),
          totaux: {
            qt: 0,
            ht: 0,
          },
          totalSaisieQt: 0,
          totalArticle: {
            total: null,
            global: null,
          },
          orderManagerData: orderManagerData, // orderManagerVue.vm,
          idSelected: "", // echangeur.currentOrder._id,
          drift: null,
          zoomTrigger: null,
          pane: null,
          mayCreateOrder: mayCreateOrder,
        };
      },
      watch: {
        async "orderManagerData.currentOrder._id"() {
          await this.updateRecalc()
        },
      },
      methods: {
        async updateRecalc() {
          //

          console.log(`🛒 updateRecalc `,orderManagerData.currentOrder);
      
          const p = {
            reference: this.product.reference,
            env: Store.get("getURUL")()
          };

          if (orderManagerData.currentOrder && orderManagerData.currentOrder._id) {
            p._id = this.orderManagerData.currentOrder._id;
            if (orderManagerData.currentOrder.onstock && orderManagerData.currentOrder.codestock) {
              this.codeStock = orderManagerData.currentOrder.codestock;
              console.log('🛒  codestock',this.codeStock );
            }
          }
          const product = await THIS.rest("b2b.saisie.get", p);


 

          this.lcodestock = (product.toc.onstock && product.stock) ? product.stock.lcodestock : [];
          this.codestock = (orderManagerData?.currentOrder?.codestock) ? orderManagerData?.currentOrder?.codestock : null;
          this.stocks = (product.stock && product.stock.rows) ? product.stock.rows : [];


          console.log('🛒  lcodestock', this.lcodestock,this.stocks,this.codeStock ); 


          // onstock:      // affichage en stock ou non
          // stocks:       // tableau des stocks
          // lcodestock :  // liste des code stock 
          // codestock:    // code stock utilisée pour la saisie

 
          const uvcSaisies = buildUvcSaisies(product, null, null, this.codestock); 
          this.currentOrder = this.orderManagerData.currentOrder;
          this.saisie.uvc = uvcSaisies;
          this.product.verifie = product.verifie;
 
          //const stockEstDispo = stockss.stocks.some((x) => x.stockdispo > 0);
          //console.log('stockEstDispo', stockEstDispo);

          if (this.onstock && product.verifie.ok) {
            const utilisateurEstProprietaire = this.currentOrder.quiAff.k === CTX.session.realuser;
            const commandeEstEnBrouillon = this.currentOrder.status == "10";

            // => ref mais pas de stock
            //     ->  Reference pas affichée
            //     ->  Si ligne panier
            //         - suppression ligne panier

            // => ref a du stock
            //     -> Saisie 
            //     -> ref affichée

            // => ref stock 1 mais 1 dans le panier
            //     -> ref affichée dans les line liste
            //     -> si non propriétaire du panier
            //         - ref non saisissable
            //     -> si propriétaire du panier
            //         - ref saisissable

            // if (stockEstDispo && utilisateurEstProprietaire) {
            //   this.product.verifie.ok = false;
            //   product.verifie.message = "You're not the owner of the order";
            //   return;
            // }

            // if (stockEstDispo && commandeEstEnBrouillon) {
            //   this.product.verifie.ok = false;
            //   product.verifie.message = "Order is in draft mode";
            //   return;
            // }

            // if (!stockEstDispo) {
            //   this.product.verifie.ok = false;
            //   product.verifie.message = "No stock available for this product";
            //   return;
            // }
          }

          this.recalc();
        },

        saisieClass(saisie, item) {
          const isInvalid = item.qt > parseInt(item.ostock?.sasissable) || item.qt < 0 ? 'is-invalid' : ''
          const disable = saisie.isGlobal || ((this.onstock && !item.ostock) || (item.ostock && item.ostock.sasissable == 0)) ? 'bg-light' : '_tai'
          return `form-control text-center px-0 m-0 input-number ${isInvalid} ${disable}`;
        },

        saisieStock(item) {
          return (!item.ostock || item.ostock.sasissable == 0) ? "-" : item.ostock.sasissable
        },

        showCart() {
          //
        },

        getStock(ean, codestock) {
          // const a = this.stocks.stocks.filter((i) => (i.ean == ean && i.codestock == codestock));
          //console.log("this.stocks", this.stocks)


          let astk = this.stocks.find((i) => (i.codestock == codestock));

          let stockEan = astk.stock.find((i) => (i.ean == ean));
          if (!stockEan) stockEan = { dispo: "-" }
          return { dispo: stockEan.stockdispo || "-" }

          // let nb = 0;
          // let dispo = 0;
          // let resa = 0;
          // let info = '';
          // for (const s of a) {
          //   let rownb = (s.initial - s.commandes - s.stockreserve);
          //   if (rownb < 0) {
          //     rownb = 0;
          //   }
          //   resa += s.stockreserve;
          //   nb += rownb;
          //   if (s.datearrivage && s.datearrivage > moment().format("YYYY-MM-DD")) {
          //     info += s.initial + '-' + s.commandes + '-' + s.stockreserve + "=" + rownb + " on " + s.datearrivage + "\n";
          //   } else {
          //     dispo += rownb;
          //     info += s.initial + '-' + s.commandes + '-' + s.stockreserve + "=" + rownb + " NOW" + "\n";
          //   }
          // }
          // return { total: nb, dispo: (dispo < 1 ? '-' : dispo), reserves: resa, info: info, a }
        },

        recalc() {
          if (this.isTailleunique) {
            if (this.saisie.isGlobal) {
              this.saisie.isGlobal = false;
              this.saisie.uvc[0].qt = this.saisie.qtGlobal;
            }
          }
          let totQt = 0;
          let totHt = 0;
          let prixGlobal = 0;
          for (const uvc of this.saisie.uvc) {
            if (uvc.qt) {
              totQt += uvc.qt;
              totHt += uvc.qt * uvc.prix.prix
            } else {
              uvc.qt = "";
            }
            if (!prixGlobal) prixGlobal = uvc.prix; // prix global, on prend le 1er prix
          }
          this.totalSaisieQt = totQt;
          //
          if (this.saisie.isGlobal) {
            this.totaux.qt = this.saisie.qtGlobal ? this.saisie.qtGlobal : 0;
            this.totaux.prix = prixGlobal;
            this.totaux.ht = this.saisie.qtGlobal ? this.saisie.qtGlobal * prixGlobal : 0;
          } else {
            this.totaux.qt = totQt;
            this.totaux.prix = prixGlobal;
            this.totaux.ht = totHt;
          }
        },
        switchGlobal(value) {
          this.saisie.isGlobal = value;
          this.recalc();
        },
        greetGlobal(event) {
          event.target.select();
          this.switchGlobal(true);
        },
        greetTotal(event) {
          event.target.select();
          this.switchGlobal(false);
        },
        toPrixOrder(value) {
          if (this.currentOrder) {
            return toPrix(value, this.currentOrder.devise);
          }
        },
        toPrix(value, devise) {
          return toPrix(value, devise);
        },
        importQt() {
          if (this.product.savethefrom?.ct && Object.keys(this.product.savethefrom.ct).length !== 0) {
            let ct = this.product.savethefrom.ct;
            let coufrom = this.product.savethefrom.cou[0].k;
            let cou = this.product.product.cou[0].k; //BK01

            for (let tc of this.product.savethefrom.tai) {
              let uvc = cou + "_" + tc.k;
              let qt = ct[coufrom + "_" + tc.k].qt;

              this.saisie.uvc.map((u) => {
                if (uvc == u.cou + "_" + u.tai) u.qt = qt;
              });
            }
            this.recalc();
          }
        },
        changeQt(uvc) {
          const qt = parseInt(uvc.qt);
          uvc.qt = qt ? qt : "";
          this.recalc();
        },
        changeGlobal() {
          const qt = parseInt(this.saisie.qtGlobal);
          this.saisie.qtGlobal = qt ? qt : "";
          this.recalc();
        },
        eraseInput() {
          for (const uvc of this.saisie.uvc) uvc.qt = "";
          this.saisie.qtGlobal = "";
          this.recalc();
        },
        fin() {
          THIS.fin();
        },
        createOrder() {
          Store.get("creatOrder")(function (_id) { });
          //await this.updateRecalc();   //jp       
        },
        viewOrder() {
          if (this.currentOrder && this.currentOrder._id) {
            hash.lance("orderValidate", {
              _id: this.currentOrder._id,
              formLinelist: true,
            });
            //await this.updateRecalc();   //jp         
          }
        },

        goToAdminPageProduct() {
          //const URL = "olddmkadmin.html#productList#productEdit&canal=0&_id=" + this.product.product._id
          const URL = "dmkadmin.html#productList/productEdit&_id=" + this.product.product._id + '&source=front'
          window.open(URL, "_blank");
        },

        may(droit) {
          return may(droit);
        },

        selectOrder() {
          Store.get("selectOrder")();
          //await this.updateRecalc();//jp          
          // console.log('ici')
        },
        goToSubstitute(r) {
          const p = { reference: r, linelist: echangeur.hash.linelist };
          // _id: this.orderManagerData.currentOrder._id

          hash.chaine("productSaisie", p);
        },
        async addToOrderAndFinalize() {

          const isInvalid = document.querySelector('.is-invalid')
          if (isInvalid !== null) return

          const form = {
            _id: this.orderManagerData.currentOrder._id,
            reference: this.product.reference,
            tc: this.saisie.uvc.map((u) => ({
              cou: u.cou,
              tai: u.tai,
              qt: u.qt,
              uvc: u.uvc,
            })),
            isGlobal: this.saisie.isGlobal,
            qtGlobal: this.saisie.qtGlobal,
          };
          //
          /* console.log("form", form); */
          let data = await THIS.rest("b2b.saisie.save", {}, form);
          Store.get("updateTotaux")(data);
          //
          if (this.currentOrder && this.currentOrder._id) {
            hash.lance("orderValidate", {
              _id: this.currentOrder._id,
              formLinelist: true,
            });
          }
        },

        zoom() {
          const thisparent = this;
          const modaleApp = createApp({
            data: () => ({
              media: thisparent.media,
            }),
            methods: {
              close() {
                ModalHelper.hide();
              },
            },
            mounted() {
              ModalHelper.show(function () {
                modaleApp.unmount();
              });
              var splide = new Splide("#image-carousel", {
                video: {
                  loop: true,
                  mute: true,
                  autoplay: true,
                  disableOverlayUI: true,
                  hideControls: true,
                  playerOptions: {
                    //htmlVideo: { controls: false },
                    htmlVideo: {},
                  },
                },
              });

              splide.mount({ Video });
            },
          });
          modaleApp.mount(ModalHelper.html(htmlZoom).container);
        },

        async addToOrder() {

          const isInvalid = document.querySelector('.is-invalid')
          if (isInvalid !== null) return

          const form = {
            _id: this.orderManagerData.currentOrder._id,
            reference: this.product.reference,
            tc: this.saisie.uvc.map((u) => ({
              cou: u.cou,
              tai: u.tai,
              qt: u.qt,
              uvc: u.uvc,
            })),
            isGlobal: this.saisie.isGlobal,
            qtGlobal: this.saisie.qtGlobal,
          };
          //
          /* console.log("form", form); */
          let data = await THIS.rest("b2b.saisie.save", {}, form);
          Store.get("updateTotaux")(data);
          //
          THIS.fin();
        },

      },
      async mounted() {

        // this.updateRecalc()

        const thisparent = this;

        const driftImgs = document.querySelectorAll(".zoom-trigger");
        const joe = document.querySelector(".splide__list");
        this.pane = document.querySelector(".zoom-area");

        // zoom-trigger

        if (this.drift) this.drift.destroy();

        for (const img of driftImgs) {
          new Drift(img, {
            paneContainer: this.pane,
            inlinePane: false,
            zoomFactor: 3, // Taille du zoom
          });
        }

        joe.addEventListener("mouseover", function () {
          thisparent.pane.style.display = "block";
        });
        joe.addEventListener("mouseout", function () {
          thisparent.pane.style.display = "none";
        });

        var splide = new Splide("#main-carousel", {
          video: {
            loop: true,
            mute: true,
            autoplay: true,
            disableOverlayUI: true,
            hideControls: true,
            playerOptions: {
              //htmlVideo: { controls: false },
              htmlVideo: {},
            },
          },
          pagination: false,
          arrows: false,
        });

        var thumbnails = document.getElementsByClassName("thumbnail");
        var current;

        for (var i = 0; i < thumbnails.length; i++) {
          initThumbnail(thumbnails[i], i);
        }

        function initThumbnail(thumbnail, index) {
          thumbnail.addEventListener("click", function () {
            splide.go(index);
          });
        }

        splide.on("mounted move", function () {
          var thumbnail = thumbnails[splide.index];
          thisparent.currentStartImage = splide.index;
          if (thumbnail) {
            if (current) {
              current.classList.remove("is-active");
            }

            thumbnail.classList.add("is-active");
            current = thumbnail;
          }
        });

        splide.mount({ Video });
        this.recalc();

        const moveArrowInput = () => {
          const inputs = document.querySelectorAll("._tabSaisie ._tai");

          inputs.forEach((input, index) => {
            input.addEventListener("keydown", function (e) {
              const key = e.which || e.keyCode;
              if (key === 39 /* Droite */) {
                e.preventDefault();
                if (index + 1 < inputs.length) {
                  inputs[index + 1].setSelectionRange(0, inputs[index + 1].value.length);
                  inputs[index + 1].focus();
                }
              }
              if (key === 37 /* Gauche */) {
                e.preventDefault();
                if (index > 0) {
                  inputs[index - 1].setSelectionRange(0, inputs[index - 1].value.length);
                  inputs[index - 1].focus();
                }
              }
            });
          });
        };
        moveArrowInput();

      },
    });

    //app.mount(THIS.c$("._vueChargement")[0]);
    this.vm = app.mount(THIS.c$('._vueChargement')[0]);

  },
};

export default {
  productSaisie: { js, html },
};